module.exports = __webpack_public_path__ + "img/category-new-released.b7c59d56.png";